// src/hooks/useDismissibleWithExpiry.js
//
// Tracks a dismissible UI element's visibility, persisted in localStorage
// with an expiry timestamp so it automatically reappears after `durationMs`
// — survives page refreshes and browser restarts since it's backed by
// localStorage, not component state.
import { useState, useCallback } from 'react';

export function useDismissibleWithExpiry(storageKey, durationMs) {
  const isCurrentlyDismissed = () => {
    try {
      const until = parseInt(localStorage.getItem(storageKey) || '0', 10);
      return until > Date.now();
    } catch (e) {
      return false;
    }
  };

  const [dismissed, setDismissed] = useState(isCurrentlyDismissed);

  const dismiss = useCallback(() => {
    try {
      localStorage.setItem(storageKey, String(Date.now() + durationMs));
    } catch (e) {}
    setDismissed(true);
  }, [storageKey, durationMs]);

  return [dismissed, dismiss];
}
